import List from './CourseBatchList'
import Create from './CreateCourseBatch'
import Details from './CourseBatchDetails'
const exportObj = {
    List,
    Create,
    Details,
}

export default exportObj